/*
 * File: CustomModal.tsx
 * Project: a-a
 * File Created: Monday, 4th November 2024 11:59:25 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 15th April 2025 12:35:33 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import zeplinColor from '../../../theme/Color';

type CustomModalProp = {
  open?: boolean;
  handleCloseModal?: () => void;
};

const CustomLoader = ({ open = false, handleCloseModal }: CustomModalProp) => {
  return (
    <Modal
      open={open}
      // onClose={handleCloseModal}
      aria-labelledby='modal-modal-title'
      //   aria-describedby='modal-modal-description'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // position: 'relative',
        zIndex: 100,

        // height: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '14px',
          width: '156px',
          height: '112px',
          backgroundColor: zeplinColor.Neutral1,
          padding: '24px',

          '&:focus': {
            outline: 'none', // Removes the blue outline
          },
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress sx={{ color: zeplinColor.BasicBlack }} size={80} />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src='/assets/a-a-loader.svg' alt='loading' width={32} height={32} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomLoader;
